import { render, staticRenderFns } from "./EditBatch.vue?vue&type=template&id=0f09dee7&scoped=true"
import script from "./EditBatch.vue?vue&type=script&lang=js"
export * from "./EditBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f09dee7",
  null
  
)

export default component.exports